import React from 'react'
import get from 'lodash/get'
import { Form } from 'react-bootstrap'
import { Control } from 'react-hook-form'

export function fieldErrorCssClass(control: Control, name: string, cssClass?: string) {
  const { formStateRef } = control

  const isFieldTouched = formStateRef.current.isSubmitted || get(formStateRef.current.touched, name)
  const fieldError = get(formStateRef.current.errors, name)

  return fieldError && isFieldTouched ? cssClass || 'is-invalid' : ''
}

export function ErrorMessage(props: { control: Control; name: string }) {
  const { formStateRef } = props.control

  const isFieldTouched =
    formStateRef.current.isSubmitted || get(formStateRef.current.touched, props.name)
  const fieldError = get(formStateRef.current.errors, props.name)

  return fieldError && isFieldTouched ? (
    <Form.Control.Feedback type="invalid">{fieldError.message}</Form.Control.Feedback>
  ) : null
}
